/* unplugin-vue-components disabled */import { render } from "./NewAvatarSelector.vue?vue&type=template&id=57d806cc&scoped=true"
import script from "./NewAvatarSelector.vue?vue&type=script&lang=js"
export * from "./NewAvatarSelector.vue?vue&type=script&lang=js"

import "./NewAvatarSelector.vue?vue&type=style&index=0&id=57d806cc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57d806cc"]])

export default __exports__